const React = require('react');
const PropTypes = require('prop-types');

const ActionLink = props => {
    const handleClick = event => {
        event.preventDefault();
        props.onClick.apply(props.onClickContext, props.onClickParams);
    };

    return (
        <a href="#" target={props.target} title={props.title} onClick={handleClick}>
            {props.children}
        </a>
    );
};

ActionLink.propTypes = {
    children: PropTypes.any,
    target: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    onClickParams: PropTypes.array,
    onClickContext: PropTypes.any,
};

ActionLink.defaultProps = {
    target: '_self',
    onClickContext: null,
};

module.exports.constructor = ActionLink;
module.exports = ActionLink;
